"use client";

import StickyBox, { type StickyBoxCompProps } from "react-sticky-box";
import type { ComponentType, FC } from "react";

interface WithStickyProps extends StickyBoxCompProps {}

export default function WithSticky<T extends object>(
  WrappedComponent: ComponentType<T>
) {
  const StickyComponent: FC<WithStickyProps & T> = (props) => {
    const {
      offsetTop = 80,
      offsetBottom = 20,
      style,
      className,
      ...componentProps
    } = props;

    return (
      <StickyBox
        offsetTop={offsetTop}
        offsetBottom={offsetBottom}
        style={style}
        className={`${className}`}
      >
        <WrappedComponent {...(componentProps as T)} />
      </StickyBox>
    );
  };

  StickyComponent.displayName = `withSticky(${
    WrappedComponent.displayName || WrappedComponent.name || "Component"
  })`;

  return StickyComponent;
}
